module.exports = __webpack_public_path__ + "img/okend.5ab3eb50.jpg";